<template>
	<div class="container mx-auto px-4 text-white fnt-quicksand my-6">
		<p class="text-center text-2xl md:text-3xl mb-4">
			Este proyecto ha sido realizado por:
		</p>
		<p class="text-center text-4xl md:text-5xl mb-4">
			Lombardo Moreno Rodríguez
		</p>
		<p class="text-center text-xl md:text-2xl mb-10">2021</p>
		<div class="flex flex-col md:flex-row justify-center">
			<a
				href="https://www.linkedin.com/in/lombardo-m-bba399218/"
				class="text-2xl border-2 border-red-500 px-3 py-6 md:py-2 rounded-md transition-all duration-200 hover:bg-red-500 hover:text-white mb-5 md:mb-0 md:mr-5 text-center"
			>
				<i class="fab fa-linkedin"></i>
				Linked in
			</a>
			<a
				href="https://github.com/LombardoCode/MusicNow"
				class="text-2xl border-2 border-red-500 px-3 py-6 md:py-2 rounded-md transition-all duration-200 hover:bg-red-500 hover:text-white mb-5 md:mb-0 text-center"
			>
				<i class="fab fa-github"></i>
				Github
			</a>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style>
.fnt-quicksand {
	font-family: "Quicksand", "Arial", sans-serif;
}
</style>
